import React from 'react'
import "./Header.css";
import Logo from '../../Assets/Images/logo1.png';
import Menu from '../../Assets/Images/menu.svg';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

// const customStyles = {
//   content: {
//     top: '50%',
//     left: '50%',
//     right: 'auto',
//     bottom: 'auto',
//     marginRight: '-50%',
//     transform: 'translate(-50%, -50%)',
//   },
// };

export default function Header() {
  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
     subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }
  return (
    <div className='header'>
      <div className="container">
        <a href='#' className="logo-link">
          <img src={Logo} alt="" className="header-logo" />
        </a>
        <ul className="header-list">
          <li className="header-item">
            <a href="#" className="header-link">
              Home
            </a>
          </li>
          <li className="header-item">
            <a href="#" className="header-link">
              About us
            </a>
          </li> <li className="header-item">
            <a href="#" className="header-link">
              Our Process
            </a>
          </li> <li className="header-item">
            <a href="https://wa.me/918888877444" className="header-link">
              Contact us
            </a>
          </li>
        </ul>
        <a href="https://wa.me/918888877444" className="header-btn">
          Get a Quote
        </a>
  
        <button onClick={openModal} className="menu-btn"><img src={Menu} alt="" className="menu-icon" />
</button>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
         contentLabel="Example Modal"
      >
         <button onClick={closeModal} className="modal-close">&times;</button>
     <ul className="modal-list">
      <li className="modal-item">
        <a href="/" className="modal-link">
          Home
        </a>
      </li>
      <li className="modal-item">
        <a href="#about" className="modal-link">
        About us
        </a>
      </li>
      <li className="modal-item">
        <a href="#" className="modal-link">
        Our Process
        </a>
      </li>
      <li className="modal-item">
        <a href="https://wa.me/918888877444" className="modal-link">
        Contact us
        </a>
      </li>
     
    </ul>
    <a href="https://wa.me/918888877444" className=" header-modal-btn">
          Get a Quote
        </a>
      </Modal>
      </div>

    </div>
  )
}
